import { DataGrid, type DataGridProps } from '@shared/components';

import { columns } from './columns';
import { type QuestionListDataGridRow } from './types';

export type QuestionListDataGridProps = Pick<
  DataGridProps<QuestionListDataGridRow>,
  | 'rows'
  | 'onCellClick'
  | 'onRowClick'
  | 'loading'
  | 'onRowSelectionModelChange'
  | 'disableRowSelectionOnClick'
> & {
  selectionModel?: string[];
  withCheckbox?: boolean;
};

export default function QuestionListDataGrid(props: Readonly<QuestionListDataGridProps>) {
  const {
    rows,
    onCellClick,
    onRowClick,
    loading: isLoading,
    onRowSelectionModelChange,
    withCheckbox = false,
    selectionModel,
    disableRowSelectionOnClick: shouldDisableRowSelectionOnClick = false,
  } = props;

  return (
    <DataGrid
      rows={rows}
      columns={columns}
      onCellClick={onCellClick}
      onRowClick={onRowClick}
      rowHeight={48}
      columnHeaderHeight={48}
      loading={isLoading}
      onRowSelectionModelChange={onRowSelectionModelChange}
      disableRowSelectionOnClick={shouldDisableRowSelectionOnClick}
      rowSelectionModel={selectionModel}
      rowSelection={withCheckbox}
      sx={(theme) => ({
        '--unstable_DataGrid-radius': theme.shape.rounded(0),
        borderRadius: theme.shape.rounded(0),
        backgroundColor: theme.palette.background.paper,
        overflow: 'hidden',
        boxShadow: 'none',
        '.MuiDataGrid-cell': {
          padding: theme.spacing(1.5, 2),
        },
        '.MuiDataGrid-columnHeader': {
          padding: theme.spacing(3),
          backgroundColor: theme.palette.grey[100],
          borderBottom: `1px solid ${theme.palette.divider}`,
        },
        '.MuiDataGrid-row > .MuiDataGrid-withBorderColor': {
          borderColor: theme.palette.divider,
        },
        '.MuiDataGrid-cell:last-child': {
          padding: theme.spacing(1.5),
        },
      })}
      disableColumnMenu
      hideFooter
    />
  );
}
